import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../Loader/Loader";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";
import { copyToClipboard, trimAddress } from "../../utils/helper";
import "react-phone-input-2/lib/style.css";
import { IoCopyOutline } from "react-icons/io5";
import { BASE_URL, STANDARD_IMAGE_URL } from "../../utils/constant";
import { Icon } from "@iconify/react/dist/iconify.js";

const NftCollectionViewLayer = () => {
     const [loading, setLoading] = useState(false);
     const [data, setData] = useState(null);
     const { id } = useParams();
     const { AsyncGetApiCall } = useApi();

     const fetchCollection = async () => {
          setLoading(true);
          try {
               const result = await AsyncGetApiCall(`/collection/view?collectionId=${id}`);
               console.log("result of fetchCollection: ", result);

               if (result.errors) {
                    toast.error(result.errors[0]);
               } else if (result.success) {
                    setData(result?.data);
               }
          } catch (error) {
               toast.error("An error occurred while fetching Collection details");
          }
          setLoading(false);
     };
     console.log("image", `${BASE_URL}/uploads/${data?.image}`)
     useEffect(() => {
          fetchCollection();
     }, []);

     return (
          <>
               {loading && <Loader />}
               <div className="row gy-4">
                    {/* Left Card - NFT Image */}
                    <div className="col-lg-4">
                         <div className="card position-relative border radius-16 overflow-hidden bg-base h-100">
                              <img
                                   src={data?.image ? `${BASE_URL}/uploads/${data?.image}` : STANDARD_IMAGE_URL}
                                   alt="Collection"
                                   className="w-100 object-fit-cover"
                                   style={{ height: "100%", minHeight: "400px" }}
                              />
                         </div>
                    </div>

                    {/* Right Column */}
                    <div className="col-lg-6">
                         {/* Top Right Card - NFT Data */}
                         <div className="card mb-10">
                              <div className="card-body p-24">
                                   <h5 className="mb-16">Collection Details</h5>
                                   <ul>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Id</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {trimAddress(data?._id, 10, 8) || "N/A"}
                                                  {data?._id && (
                                                       <button
                                                            onClick={() => copyToClipboard(data?._id)}
                                                            className="ms-3 p-0 border-0 bg-transparent"
                                                            style={{ lineHeight: 1 }}
                                                       >
                                                            <IoCopyOutline />
                                                       </button>
                                                  )}
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Name</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {data?.name || "N/A"}
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Address</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {trimAddress(data?.address, 10, 8) || "N/A"}
                                                  {data?.address && (
                                                       <button
                                                            onClick={() => copyToClipboard(data?.address)}
                                                            className="ms-3 p-0 border-0 bg-transparent"
                                                            style={{ lineHeight: 1 }}
                                                       >
                                                            <IoCopyOutline />
                                                       </button>
                                                  )}
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Category</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {data?.category || "N/A"}
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Type</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {data?.type || "N/A"}
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Created At</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  {data?.createdAt
                                                       ? new Date(data.createdAt).toLocaleString("en-GB", {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            second: "2-digit",
                                                            hour12: true,
                                                       })
                                                       : "N/A"}
                                             </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-2 mt-4">
                                             <span className="w-30 text-md fw-semibold text-primary-light">Status</span>
                                             <span>:</span>
                                             <span className="w-70 text-secondary-light fw-medium">
                                                  <span
                                                       className={` badge ${data?.isActive
                                                            ? 'bg-success-100 text-success-600'
                                                            : 'bg-danger-100 text-danger-600'
                                                            } text-sm py-4 px-10 radius-4`}
                                                  >
                                                       {data?.isActive ? 'Active' : 'Inactive'}
                                                  </span>
                                             </span>
                                        </li>
                                   </ul>
                              </div>
                         </div>
                    </div>
               </div>
          </>
     );
};

export default NftCollectionViewLayer;